var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.875C12.0703 6.875 9.41406 8.4375 7.92969 10.9375C6.48438 13.4766 6.48438 16.5625 7.92969 19.0625C9.41406 21.6016 12.0703 23.125 15 23.125C17.8906 23.125 20.5469 21.6016 22.0312 19.0625C23.4766 16.5625 23.4766 13.4766 22.0312 10.9375C20.5469 8.4375 17.8906 6.875 15 6.875ZM15 25C11.4062 25 8.125 23.125 6.32812 20C4.53125 16.9141 4.53125 13.125 6.32812 10C8.125 6.91406 11.4062 5 15 5C18.5547 5 21.8359 6.91406 23.6328 10C25.4297 13.125 25.4297 16.9141 23.6328 20C21.8359 23.125 18.5547 25 15 25ZM11.8359 11.8359C12.1875 11.4844 12.7734 11.4844 13.125 11.8359L14.9609 13.6719L16.7969 11.8359C17.1875 11.4844 17.7734 11.4844 18.125 11.8359C18.5156 12.2266 18.5156 12.8125 18.125 13.1641L16.2891 15L18.125 16.8359C18.5156 17.2266 18.5156 17.8125 18.125 18.1641C17.7734 18.5547 17.1875 18.5547 16.7969 18.1641L14.9609 16.3281L13.125 18.1641C12.7734 18.5547 12.1875 18.5547 11.8359 18.1641C11.4453 17.8125 11.4453 17.2266 11.8359 16.8359L13.6719 15L11.8359 13.1641C11.4453 12.8125 11.4453 12.2266 11.8359 11.8359Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.71f5190ef6929292b5ddaa9f5f4be6ce.svg";
export { ForwardRef as ReactComponent };